import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const fetchRecipes = async (params = {}) => {
  const { data } = await api.get("/recipes", { params });
  return data;
};
export const fetchFeatured = async () => (await api.get("/recipes/featured")).data;
export const fetchNew = async () => (await api.get("/recipes/new")).data;
export const fetchRecipe = async (slug) => (await api.get(`/recipes/${slug}`)).data;
export const fetchRelated = async (slug) => (await api.get(`/recipes/${slug}/related`)).data;
export const recordView = async (slug) => (await api.post(`/recipes/${slug}/view`)).data;
export const subscribe = async (payload) => (await api.post("/subscribers", payload)).data;
export const fetchPublicSettings = async () => (await api.get("/settings")).data;

// Auth
export const authMe = async () => (await api.get("/auth/me")).data;
export const authExchange = async (session_id) =>
  (await api.post("/auth/session", { session_id })).data;
export const authLogout = async () => (await api.post("/auth/logout")).data;

// Admin
export const adminCreateRecipe = async (payload) =>
  (await api.post("/recipes", payload)).data;
export const adminUpdateRecipe = async (slug, payload) =>
  (await api.put(`/recipes/${slug}`, payload)).data;
export const adminDeleteRecipe = async (slug) =>
  (await api.delete(`/recipes/${slug}`)).data;
export const adminListAllRecipes = async (status) =>
  (await api.get("/admin/recipes", { params: status ? { status } : {} })).data;
export const adminPublishRecipe = async (slug) =>
  (await api.post(`/admin/recipes/${slug}/publish`)).data;
export const adminUnpublishRecipe = async (slug) =>
  (await api.post(`/admin/recipes/${slug}/unpublish`)).data;
export const adminListSubscribers = async () =>
  (await api.get("/admin/subscribers")).data;
export const adminDeleteSubscriber = async (id) =>
  (await api.delete(`/admin/subscribers/${id}`)).data;

// Gmail
export const gmailStatus = async () => (await api.get("/admin/gmail/status")).data;
export const gmailStartOAuth = async () =>
  (await api.get("/oauth/gmail/start")).data;
export const gmailDisconnect = async () =>
  (await api.post("/admin/gmail/disconnect")).data;

// Pipeline
export const pipelineLogs = async (limit = 25) =>
  (await api.get("/admin/pipeline/logs", { params: { limit } })).data;
export const pipelineRunNow = async () =>
  (await api.post("/admin/pipeline/run-now")).data;

// Site settings
export const adminGetSettings = async () => (await api.get("/admin/settings")).data;
export const adminUpdateSettings = async (payload) =>
  (await api.put("/admin/settings", payload)).data;

// Helpers
export const withAmazonTag = (url, tag) => {
  if (!url || !tag) return url;
  try {
    const u = new URL(url);
    if (!/amazon\./i.test(u.hostname)) return url;
    u.searchParams.set("tag", tag);
    return u.toString();
  } catch {
    return url;
  }
};
export const adminUpload = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { id, url, path }
};

// Build absolute URL for an image returned by upload (relative /api/files/{id})
export const fileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};
